export const LOCIZE_PROJECT_ID = process.env.NEXT_PUBLIC_LOCIZE_PROJECT_ID ?? '';

export const LOCIZE_API_KEY = process.env.NEXT_PUBLIC_LOCIZE_API_KEY ?? '';

export const LOCIZE_VERSION = 'latest';

export const IS_CDN_ENABLED = process.env.NEXT_PUBLIC_ENV === 'development';

/**
 * 번역 편집기는 t() 결과에 zero-width 메타를 심어 화면의 글자와 번역 키를 잇는다.
 * 운영에 켜지면 모든 문구에 보이지 않는 문자가 섞이므로 개발 환경에서만 켠다.
 */
export const IS_TRANSLATION_EDITOR_ENABLED =
  process.env.NEXT_PUBLIC_ENV === 'development' || process.env.NEXT_PUBLIC_ENV === 'localhost';
